// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file transportation/v1/service.proto (package transportation.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Base, ID } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file transportation/v1/service.proto.
 */
export const file_transportation_v1_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_types]);

/**
 * Service message definition
 *
 * @generated from message transportation.v1.Service
 */
export type Service = Message<"transportation.v1.Service"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID service_type_id = 2;
   */
  serviceTypeId?: ID;

  /**
   * @generated from field: transportation.v1.ServiceStatus status = 3;
   */
  status: ServiceStatus;

  /**
   * @generated from field: string document_number = 4;
   */
  documentNumber: string;

  /**
   * @generated from field: string rank = 5;
   */
  rank: string;

  /**
   * @generated from field: int32 priority = 6;
   */
  priority: number;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_window_start = 7;
   */
  scheduledWindowStart?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_window_end = 8;
   */
  scheduledWindowEnd?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp started_at = 9;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp completed_at = 10;
   */
  completedAt?: Timestamp;

  /**
   * @generated from field: string internal_notes = 11;
   */
  internalNotes: string;

  /**
   * @generated from field: string external_notes = 12;
   */
  externalNotes: string;

  /**
   * @generated from field: string driver_notes = 13;
   */
  driverNotes: string;

  /**
   * @generated from field: types.ID facility_group_id = 14;
   */
  facilityGroupId?: ID;

  /**
   * @generated from field: types.ID facility_id = 15;
   */
  facilityId?: ID;

  /**
   * @generated from field: types.ID destination_facility_id = 16;
   */
  destinationFacilityId?: ID;

  /**
   * @generated from field: types.ID driver_id = 17;
   */
  driverId?: ID;

  /**
   * @generated from field: types.ID hauler_id = 18;
   */
  haulerId?: ID;

  /**
   * @generated from field: types.ID truck_id = 19;
   */
  truckId?: ID;

  /**
   * @generated from field: types.ID trailer_id = 20;
   */
  trailerId?: ID;

  /**
   * @generated from field: bool non_default_truck = 21;
   */
  nonDefaultTruck: boolean;

  /**
   * @generated from field: bool non_default_trailer = 22;
   */
  nonDefaultTrailer: boolean;

  /**
   * @generated from field: types.ID route_id = 23;
   */
  routeId?: ID;

  /**
   * @generated from field: string route_position = 24;
   */
  routePosition: string;

  /**
   * @generated from field: types.ID account_id = 25;
   */
  accountId?: ID;

  /**
   * @generated from field: types.ID account_address_id = 26;
   */
  accountAddressId?: ID;

  /**
   * @generated from field: types.ID contact_id = 27;
   */
  contactId?: ID;

  /**
   * @generated from field: google.protobuf.Timestamp assigned_at = 28;
   */
  assignedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp estimated_arrival = 29;
   */
  estimatedArrival?: Timestamp;

  /**
   * @generated from field: string assignment_status = 30;
   */
  assignmentStatus: string;

  /**
   * @generated from field: string driver_progress = 31;
   */
  driverProgress: string;

  /**
   * @generated from field: string hauler_progress = 32;
   */
  haulerProgress: string;

  /**
   * @generated from field: string address_type = 33;
   */
  addressType: string;

  /**
   * @generated from field: string street_address = 34;
   */
  streetAddress: string;

  /**
   * @generated from field: string city = 35;
   */
  city: string;

  /**
   * @generated from field: string state = 36;
   */
  state: string;

  /**
   * @generated from field: string postal_code = 37;
   */
  postalCode: string;

  /**
   * @generated from field: string country = 38;
   */
  country: string;

  /**
   * @generated from field: bool is_mailing_address = 39;
   */
  isMailingAddress: boolean;

  /**
   * @generated from field: string latitude = 40;
   */
  latitude: string;

  /**
   * @generated from field: string longitude = 41;
   */
  longitude: string;

  /**
   * @generated from field: types.Base base = 42;
   */
  base?: Base;
};

/**
 * Describes the message transportation.v1.Service.
 * Use `create(ServiceSchema)` to create a new message.
 */
export const ServiceSchema: GenMessage<Service> = /*@__PURE__*/
  messageDesc(file_transportation_v1_service, 0);

/**
 * LoadBoard - custom type
 *
 * @generated from message transportation.v1.LoadBoard
 */
export type LoadBoard = Message<"transportation.v1.LoadBoard"> & {
  /**
   * @generated from field: repeated transportation.v1.Service services = 1;
   */
  services: Service[];

  /**
   * @generated from field: repeated string drivers = 2;
   */
  drivers: string[];
};

/**
 * Describes the message transportation.v1.LoadBoard.
 * Use `create(LoadBoardSchema)` to create a new message.
 */
export const LoadBoardSchema: GenMessage<LoadBoard> = /*@__PURE__*/
  messageDesc(file_transportation_v1_service, 1);

/**
 * ServiceAction - custom type
 *
 * @generated from message transportation.v1.ServiceAction
 */
export type ServiceAction = Message<"transportation.v1.ServiceAction"> & {
  /**
   * @generated from field: string action_type = 1;
   */
  actionType: string;

  /**
   * @generated from field: string asset_id = 2;
   */
  assetId: string;

  /**
   * @generated from field: string asset_type_id = 3;
   */
  assetTypeId: string;

  /**
   * @generated from field: int32 quantity = 4;
   */
  quantity: number;

  /**
   * @generated from field: int32 asset_group = 5;
   */
  assetGroup: number;

  /**
   * @generated from field: string asset = 6;
   */
  asset: string;

  /**
   * @generated from field: string asset_type = 7;
   */
  assetType: string;
};

/**
 * Describes the message transportation.v1.ServiceAction.
 * Use `create(ServiceActionSchema)` to create a new message.
 */
export const ServiceActionSchema: GenMessage<ServiceAction> = /*@__PURE__*/
  messageDesc(file_transportation_v1_service, 2);

/**
 * ServiceTransitionInput - custom input type
 *
 * @generated from message transportation.v1.ServiceTransitionInput
 */
export type ServiceTransitionInput = Message<"transportation.v1.ServiceTransitionInput"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string notes = 3;
   */
  notes: string;
};

/**
 * Describes the message transportation.v1.ServiceTransitionInput.
 * Use `create(ServiceTransitionInputSchema)` to create a new message.
 */
export const ServiceTransitionInputSchema: GenMessage<ServiceTransitionInput> = /*@__PURE__*/
  messageDesc(file_transportation_v1_service, 3);

/**
 * ServiceAssignInput - custom input type
 *
 * @generated from message transportation.v1.ServiceAssignInput
 */
export type ServiceAssignInput = Message<"transportation.v1.ServiceAssignInput"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string assignment_status = 2;
   */
  assignmentStatus: string;

  /**
   * @generated from field: string driver_id = 3;
   */
  driverId: string;

  /**
   * @generated from field: string hauler_id = 4;
   */
  haulerId: string;

  /**
   * @generated from field: string truck_id = 5;
   */
  truckId: string;

  /**
   * @generated from field: string trailer_id = 6;
   */
  trailerId: string;

  /**
   * @generated from field: string estimated_arrival = 7;
   */
  estimatedArrival: string;
};

/**
 * Describes the message transportation.v1.ServiceAssignInput.
 * Use `create(ServiceAssignInputSchema)` to create a new message.
 */
export const ServiceAssignInputSchema: GenMessage<ServiceAssignInput> = /*@__PURE__*/
  messageDesc(file_transportation_v1_service, 4);

/**
 * ServiceAssetTypeInput - custom input type
 *
 * @generated from message transportation.v1.ServiceAssetTypeInput
 */
export type ServiceAssetTypeInput = Message<"transportation.v1.ServiceAssetTypeInput"> & {
  /**
   * @generated from field: string asset_type_id = 1;
   */
  assetTypeId: string;

  /**
   * @generated from field: double quantity = 2;
   */
  quantity: number;

  /**
   * @generated from field: int32 asset_group = 3;
   */
  assetGroup: number;
};

/**
 * Describes the message transportation.v1.ServiceAssetTypeInput.
 * Use `create(ServiceAssetTypeInputSchema)` to create a new message.
 */
export const ServiceAssetTypeInputSchema: GenMessage<ServiceAssetTypeInput> = /*@__PURE__*/
  messageDesc(file_transportation_v1_service, 5);

/**
 * ServiceAssetInput - custom input type
 *
 * @generated from message transportation.v1.ServiceAssetInput
 */
export type ServiceAssetInput = Message<"transportation.v1.ServiceAssetInput"> & {
  /**
   * @generated from field: string asset_id = 1;
   */
  assetId: string;
};

/**
 * Describes the message transportation.v1.ServiceAssetInput.
 * Use `create(ServiceAssetInputSchema)` to create a new message.
 */
export const ServiceAssetInputSchema: GenMessage<ServiceAssetInput> = /*@__PURE__*/
  messageDesc(file_transportation_v1_service, 6);

/**
 * ServiceActionInput - custom input type
 *
 * @generated from message transportation.v1.ServiceActionInput
 */
export type ServiceActionInput = Message<"transportation.v1.ServiceActionInput"> & {
  /**
   * @generated from field: string action_type = 1;
   */
  actionType: string;

  /**
   * @generated from field: string asset_id = 2;
   */
  assetId: string;

  /**
   * @generated from field: string asset_type_id = 3;
   */
  assetTypeId: string;

  /**
   * @generated from field: int32 quantity = 4;
   */
  quantity: number;

  /**
   * @generated from field: int32 asset_group = 5;
   */
  assetGroup: number;
};

/**
 * Describes the message transportation.v1.ServiceActionInput.
 * Use `create(ServiceActionInputSchema)` to create a new message.
 */
export const ServiceActionInputSchema: GenMessage<ServiceActionInput> = /*@__PURE__*/
  messageDesc(file_transportation_v1_service, 7);

/**
 * Request/Response messages for Service queries
 *
 * @generated from message transportation.v1.GetServiceRequest
 */
export type GetServiceRequest = Message<"transportation.v1.GetServiceRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.GetServiceRequest.
 * Use `create(GetServiceRequestSchema)` to create a new message.
 */
export const GetServiceRequestSchema: GenMessage<GetServiceRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_service, 8);

/**
 * @generated from message transportation.v1.GetServiceResponse
 */
export type GetServiceResponse = Message<"transportation.v1.GetServiceResponse"> & {
  /**
   * @generated from field: transportation.v1.Service service = 1;
   */
  service?: Service;
};

/**
 * Describes the message transportation.v1.GetServiceResponse.
 * Use `create(GetServiceResponseSchema)` to create a new message.
 */
export const GetServiceResponseSchema: GenMessage<GetServiceResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_service, 9);

/**
 * @generated from message transportation.v1.ListServicesRequest
 */
export type ListServicesRequest = Message<"transportation.v1.ListServicesRequest"> & {
  /**
   * @generated from field: transportation.v1.ListServicesFilter filter = 1;
   */
  filter?: ListServicesFilter;

  /**
   * @generated from field: repeated transportation.v1.ServiceSortOption sorting = 2;
   */
  sorting: ServiceSortOption[];

  /**
   * @generated from field: int32 offset = 3;
   */
  offset: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message transportation.v1.ListServicesRequest.
 * Use `create(ListServicesRequestSchema)` to create a new message.
 */
export const ListServicesRequestSchema: GenMessage<ListServicesRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_service, 10);

/**
 * @generated from message transportation.v1.ListServicesFilter
 */
export type ListServicesFilter = Message<"transportation.v1.ListServicesFilter"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: google.protobuf.StringValue service_type_id = 2;
   */
  serviceTypeId?: string;

  /**
   * @generated from field: transportation.v1.ServiceStatus status = 3;
   */
  status: ServiceStatus;

  /**
   * @generated from field: google.protobuf.StringValue search_term = 4;
   */
  searchTerm?: string;

  /**
   * @generated from field: types.ID organization_id = 5;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.ListServicesFilter.
 * Use `create(ListServicesFilterSchema)` to create a new message.
 */
export const ListServicesFilterSchema: GenMessage<ListServicesFilter> = /*@__PURE__*/
  messageDesc(file_transportation_v1_service, 11);

/**
 * @generated from message transportation.v1.ListServicesResponse
 */
export type ListServicesResponse = Message<"transportation.v1.ListServicesResponse"> & {
  /**
   * @generated from field: repeated transportation.v1.Service services = 1;
   */
  services: Service[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message transportation.v1.ListServicesResponse.
 * Use `create(ListServicesResponseSchema)` to create a new message.
 */
export const ListServicesResponseSchema: GenMessage<ListServicesResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_service, 12);

/**
 * Command messages
 *
 * @generated from message transportation.v1.CreateServiceRequest
 */
export type CreateServiceRequest = Message<"transportation.v1.CreateServiceRequest"> & {
  /**
   * @generated from field: transportation.v1.ServiceInput input = 1;
   */
  input?: ServiceInput;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.CreateServiceRequest.
 * Use `create(CreateServiceRequestSchema)` to create a new message.
 */
export const CreateServiceRequestSchema: GenMessage<CreateServiceRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_service, 13);

/**
 * @generated from message transportation.v1.CreateServiceResponse
 */
export type CreateServiceResponse = Message<"transportation.v1.CreateServiceResponse"> & {
  /**
   * @generated from field: transportation.v1.Service service = 1;
   */
  service?: Service;
};

/**
 * Describes the message transportation.v1.CreateServiceResponse.
 * Use `create(CreateServiceResponseSchema)` to create a new message.
 */
export const CreateServiceResponseSchema: GenMessage<CreateServiceResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_service, 14);

/**
 * @generated from message transportation.v1.UpdateServiceRequest
 */
export type UpdateServiceRequest = Message<"transportation.v1.UpdateServiceRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: transportation.v1.ServiceUpdateInput input = 2;
   */
  input?: ServiceUpdateInput;

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.UpdateServiceRequest.
 * Use `create(UpdateServiceRequestSchema)` to create a new message.
 */
export const UpdateServiceRequestSchema: GenMessage<UpdateServiceRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_service, 15);

/**
 * @generated from message transportation.v1.UpdateServiceResponse
 */
export type UpdateServiceResponse = Message<"transportation.v1.UpdateServiceResponse"> & {
  /**
   * @generated from field: transportation.v1.Service service = 1;
   */
  service?: Service;
};

/**
 * Describes the message transportation.v1.UpdateServiceResponse.
 * Use `create(UpdateServiceResponseSchema)` to create a new message.
 */
export const UpdateServiceResponseSchema: GenMessage<UpdateServiceResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_service, 16);

/**
 * @generated from message transportation.v1.DeleteServiceRequest
 */
export type DeleteServiceRequest = Message<"transportation.v1.DeleteServiceRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.DeleteServiceRequest.
 * Use `create(DeleteServiceRequestSchema)` to create a new message.
 */
export const DeleteServiceRequestSchema: GenMessage<DeleteServiceRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_service, 17);

/**
 * Input messages
 *
 * @generated from message transportation.v1.ServiceInput
 */
export type ServiceInput = Message<"transportation.v1.ServiceInput"> & {
  /**
   * @generated from field: types.ID service_type_id = 1;
   */
  serviceTypeId?: ID;

  /**
   * @generated from field: transportation.v1.ServiceStatus status = 2;
   */
  status: ServiceStatus;

  /**
   * @generated from field: string rank = 3;
   */
  rank: string;

  /**
   * @generated from field: int32 priority = 4;
   */
  priority: number;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_window_start = 5;
   */
  scheduledWindowStart?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_window_end = 6;
   */
  scheduledWindowEnd?: Timestamp;

  /**
   * @generated from field: string internal_notes = 7;
   */
  internalNotes: string;

  /**
   * @generated from field: string external_notes = 8;
   */
  externalNotes: string;

  /**
   * @generated from field: string driver_notes = 9;
   */
  driverNotes: string;

  /**
   * @generated from field: types.ID facility_group_id = 10;
   */
  facilityGroupId?: ID;

  /**
   * @generated from field: types.ID facility_id = 11;
   */
  facilityId?: ID;

  /**
   * @generated from field: types.ID destination_facility_id = 12;
   */
  destinationFacilityId?: ID;

  /**
   * @generated from field: types.ID driver_id = 13;
   */
  driverId?: ID;

  /**
   * @generated from field: types.ID hauler_id = 14;
   */
  haulerId?: ID;

  /**
   * @generated from field: types.ID truck_id = 15;
   */
  truckId?: ID;

  /**
   * @generated from field: types.ID trailer_id = 16;
   */
  trailerId?: ID;

  /**
   * @generated from field: types.ID route_id = 17;
   */
  routeId?: ID;

  /**
   * @generated from field: string route_position = 18;
   */
  routePosition: string;

  /**
   * @generated from field: types.ID account_id = 19;
   */
  accountId?: ID;

  /**
   * @generated from field: types.ID account_address_id = 20;
   */
  accountAddressId?: ID;

  /**
   * @generated from field: types.ID contact_id = 21;
   */
  contactId?: ID;

  /**
   * @generated from field: google.protobuf.Timestamp estimated_arrival = 22;
   */
  estimatedArrival?: Timestamp;

  /**
   * @generated from field: string assignment_status = 23;
   */
  assignmentStatus: string;

  /**
   * @generated from field: string address_type = 24;
   */
  addressType: string;

  /**
   * @generated from field: string street_address = 25;
   */
  streetAddress: string;

  /**
   * @generated from field: string city = 26;
   */
  city: string;

  /**
   * @generated from field: string state = 27;
   */
  state: string;

  /**
   * @generated from field: string postal_code = 28;
   */
  postalCode: string;

  /**
   * @generated from field: string country = 29;
   */
  country: string;

  /**
   * @generated from field: bool is_mailing_address = 30;
   */
  isMailingAddress: boolean;

  /**
   * @generated from field: string latitude = 31;
   */
  latitude: string;

  /**
   * @generated from field: string longitude = 32;
   */
  longitude: string;
};

/**
 * Describes the message transportation.v1.ServiceInput.
 * Use `create(ServiceInputSchema)` to create a new message.
 */
export const ServiceInputSchema: GenMessage<ServiceInput> = /*@__PURE__*/
  messageDesc(file_transportation_v1_service, 18);

/**
 * @generated from message transportation.v1.ServiceUpdateInput
 */
export type ServiceUpdateInput = Message<"transportation.v1.ServiceUpdateInput"> & {
  /**
   * @generated from field: types.ID service_type_id = 1;
   */
  serviceTypeId?: ID;

  /**
   * @generated from field: transportation.v1.ServiceStatus status = 2;
   */
  status: ServiceStatus;

  /**
   * @generated from field: google.protobuf.StringValue rank = 3;
   */
  rank?: string;

  /**
   * @generated from field: google.protobuf.Int32Value priority = 4;
   */
  priority?: number;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_window_start = 5;
   */
  scheduledWindowStart?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_window_end = 6;
   */
  scheduledWindowEnd?: Timestamp;

  /**
   * @generated from field: google.protobuf.StringValue internal_notes = 7;
   */
  internalNotes?: string;

  /**
   * @generated from field: google.protobuf.StringValue external_notes = 8;
   */
  externalNotes?: string;

  /**
   * @generated from field: google.protobuf.StringValue driver_notes = 9;
   */
  driverNotes?: string;

  /**
   * @generated from field: types.ID facility_group_id = 10;
   */
  facilityGroupId?: ID;

  /**
   * @generated from field: types.ID facility_id = 11;
   */
  facilityId?: ID;

  /**
   * @generated from field: types.ID destination_facility_id = 12;
   */
  destinationFacilityId?: ID;

  /**
   * @generated from field: types.ID driver_id = 13;
   */
  driverId?: ID;

  /**
   * @generated from field: types.ID hauler_id = 14;
   */
  haulerId?: ID;

  /**
   * @generated from field: types.ID truck_id = 15;
   */
  truckId?: ID;

  /**
   * @generated from field: types.ID trailer_id = 16;
   */
  trailerId?: ID;

  /**
   * @generated from field: types.ID route_id = 17;
   */
  routeId?: ID;

  /**
   * @generated from field: google.protobuf.StringValue route_position = 18;
   */
  routePosition?: string;

  /**
   * @generated from field: types.ID account_id = 19;
   */
  accountId?: ID;

  /**
   * @generated from field: types.ID account_address_id = 20;
   */
  accountAddressId?: ID;

  /**
   * @generated from field: types.ID contact_id = 21;
   */
  contactId?: ID;

  /**
   * @generated from field: google.protobuf.Timestamp estimated_arrival = 22;
   */
  estimatedArrival?: Timestamp;

  /**
   * @generated from field: google.protobuf.StringValue assignment_status = 23;
   */
  assignmentStatus?: string;

  /**
   * @generated from field: google.protobuf.StringValue address_type = 24;
   */
  addressType?: string;

  /**
   * @generated from field: google.protobuf.StringValue street_address = 25;
   */
  streetAddress?: string;

  /**
   * @generated from field: google.protobuf.StringValue city = 26;
   */
  city?: string;

  /**
   * @generated from field: google.protobuf.StringValue state = 27;
   */
  state?: string;

  /**
   * @generated from field: google.protobuf.StringValue postal_code = 28;
   */
  postalCode?: string;

  /**
   * @generated from field: google.protobuf.StringValue country = 29;
   */
  country?: string;

  /**
   * @generated from field: google.protobuf.BoolValue is_mailing_address = 30;
   */
  isMailingAddress?: boolean;

  /**
   * @generated from field: google.protobuf.StringValue latitude = 31;
   */
  latitude?: string;

  /**
   * @generated from field: google.protobuf.StringValue longitude = 32;
   */
  longitude?: string;
};

/**
 * Describes the message transportation.v1.ServiceUpdateInput.
 * Use `create(ServiceUpdateInputSchema)` to create a new message.
 */
export const ServiceUpdateInputSchema: GenMessage<ServiceUpdateInput> = /*@__PURE__*/
  messageDesc(file_transportation_v1_service, 19);

/**
 * TransitionServiceRequest - custom mutation request
 *
 * @generated from message transportation.v1.TransitionServiceRequest
 */
export type TransitionServiceRequest = Message<"transportation.v1.TransitionServiceRequest"> & {
  /**
   * @generated from field: transportation.v1.ServiceTransitionInput input = 1;
   */
  input?: ServiceTransitionInput;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.TransitionServiceRequest.
 * Use `create(TransitionServiceRequestSchema)` to create a new message.
 */
export const TransitionServiceRequestSchema: GenMessage<TransitionServiceRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_service, 20);

/**
 * TransitionServiceResponse - custom mutation response
 *
 * @generated from message transportation.v1.TransitionServiceResponse
 */
export type TransitionServiceResponse = Message<"transportation.v1.TransitionServiceResponse"> & {
  /**
   * @generated from field: transportation.v1.Service result = 1;
   */
  result?: Service;
};

/**
 * Describes the message transportation.v1.TransitionServiceResponse.
 * Use `create(TransitionServiceResponseSchema)` to create a new message.
 */
export const TransitionServiceResponseSchema: GenMessage<TransitionServiceResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_service, 21);

/**
 * AssignServiceRequest - custom mutation request
 *
 * @generated from message transportation.v1.AssignServiceRequest
 */
export type AssignServiceRequest = Message<"transportation.v1.AssignServiceRequest"> & {
  /**
   * @generated from field: transportation.v1.ServiceAssignInput input = 1;
   */
  input?: ServiceAssignInput;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.AssignServiceRequest.
 * Use `create(AssignServiceRequestSchema)` to create a new message.
 */
export const AssignServiceRequestSchema: GenMessage<AssignServiceRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_service, 22);

/**
 * AssignServiceResponse - custom mutation response
 *
 * @generated from message transportation.v1.AssignServiceResponse
 */
export type AssignServiceResponse = Message<"transportation.v1.AssignServiceResponse"> & {
  /**
   * @generated from field: transportation.v1.Service result = 1;
   */
  result?: Service;
};

/**
 * Describes the message transportation.v1.AssignServiceResponse.
 * Use `create(AssignServiceResponseSchema)` to create a new message.
 */
export const AssignServiceResponseSchema: GenMessage<AssignServiceResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_service, 23);

/**
 * UnassignServiceRequest - custom mutation request
 *
 * @generated from message transportation.v1.UnassignServiceRequest
 */
export type UnassignServiceRequest = Message<"transportation.v1.UnassignServiceRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.UnassignServiceRequest.
 * Use `create(UnassignServiceRequestSchema)` to create a new message.
 */
export const UnassignServiceRequestSchema: GenMessage<UnassignServiceRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_service, 24);

/**
 * UnassignServiceResponse - custom mutation response
 *
 * @generated from message transportation.v1.UnassignServiceResponse
 */
export type UnassignServiceResponse = Message<"transportation.v1.UnassignServiceResponse"> & {
  /**
   * @generated from field: transportation.v1.Service result = 1;
   */
  result?: Service;
};

/**
 * Describes the message transportation.v1.UnassignServiceResponse.
 * Use `create(UnassignServiceResponseSchema)` to create a new message.
 */
export const UnassignServiceResponseSchema: GenMessage<UnassignServiceResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_service, 25);

/**
 * ServiceStatus enum
 *
 * @generated from enum transportation.v1.ServiceStatus
 */
export enum ServiceStatus {
  /**
   * @generated from enum value: SERVICE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SERVICE_STATUS_DRAFT = 1;
   */
  DRAFT = 1,

  /**
   * @generated from enum value: SERVICE_STATUS_PLANNED = 2;
   */
  PLANNED = 2,

  /**
   * @generated from enum value: SERVICE_STATUS_ACTIVE = 3;
   */
  ACTIVE = 3,

  /**
   * @generated from enum value: SERVICE_STATUS_IN_PROGRESS = 4;
   */
  IN_PROGRESS = 4,

  /**
   * @generated from enum value: SERVICE_STATUS_COMPLETED = 5;
   */
  COMPLETED = 5,

  /**
   * @generated from enum value: SERVICE_STATUS_FAILED = 6;
   */
  FAILED = 6,

  /**
   * @generated from enum value: SERVICE_STATUS_VOIDED = 7;
   */
  VOIDED = 7,

  /**
   * @generated from enum value: SERVICE_STATUS_PAUSED = 8;
   */
  PAUSED = 8,
}

/**
 * Describes the enum transportation.v1.ServiceStatus.
 */
export const ServiceStatusSchema: GenEnum<ServiceStatus> = /*@__PURE__*/
  enumDesc(file_transportation_v1_service, 0);

/**
 * @generated from enum transportation.v1.ServiceSortOption
 */
export enum ServiceSortOption {
  /**
   * @generated from enum value: SERVICE_SORT_OPTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SERVICE_SORT_OPTION_SERVICE_TYPE_ID_ASC = 1;
   */
  SERVICE_TYPE_ID_ASC = 1,

  /**
   * @generated from enum value: SERVICE_SORT_OPTION_SERVICE_TYPE_ID_DESC = 2;
   */
  SERVICE_TYPE_ID_DESC = 2,

  /**
   * @generated from enum value: SERVICE_SORT_OPTION_STATUS_ASC = 3;
   */
  STATUS_ASC = 3,

  /**
   * @generated from enum value: SERVICE_SORT_OPTION_STATUS_DESC = 4;
   */
  STATUS_DESC = 4,

  /**
   * @generated from enum value: SERVICE_SORT_OPTION_PRIORITY_ASC = 5;
   */
  PRIORITY_ASC = 5,

  /**
   * @generated from enum value: SERVICE_SORT_OPTION_PRIORITY_DESC = 6;
   */
  PRIORITY_DESC = 6,

  /**
   * @generated from enum value: SERVICE_SORT_OPTION_SCHEDULED_WINDOW_START_ASC = 7;
   */
  SCHEDULED_WINDOW_START_ASC = 7,

  /**
   * @generated from enum value: SERVICE_SORT_OPTION_SCHEDULED_WINDOW_START_DESC = 8;
   */
  SCHEDULED_WINDOW_START_DESC = 8,

  /**
   * @generated from enum value: SERVICE_SORT_OPTION_SCHEDULED_WINDOW_END_ASC = 9;
   */
  SCHEDULED_WINDOW_END_ASC = 9,

  /**
   * @generated from enum value: SERVICE_SORT_OPTION_SCHEDULED_WINDOW_END_DESC = 10;
   */
  SCHEDULED_WINDOW_END_DESC = 10,

  /**
   * @generated from enum value: SERVICE_SORT_OPTION_COMPLETED_AT_ASC = 11;
   */
  COMPLETED_AT_ASC = 11,

  /**
   * @generated from enum value: SERVICE_SORT_OPTION_COMPLETED_AT_DESC = 12;
   */
  COMPLETED_AT_DESC = 12,

  /**
   * @generated from enum value: SERVICE_SORT_OPTION_CREATED_AT_ASC = 13;
   */
  CREATED_AT_ASC = 13,

  /**
   * @generated from enum value: SERVICE_SORT_OPTION_CREATED_AT_DESC = 14;
   */
  CREATED_AT_DESC = 14,

  /**
   * @generated from enum value: SERVICE_SORT_OPTION_UPDATED_AT_ASC = 15;
   */
  UPDATED_AT_ASC = 15,

  /**
   * @generated from enum value: SERVICE_SORT_OPTION_UPDATED_AT_DESC = 16;
   */
  UPDATED_AT_DESC = 16,
}

/**
 * Describes the enum transportation.v1.ServiceSortOption.
 */
export const ServiceSortOptionSchema: GenEnum<ServiceSortOption> = /*@__PURE__*/
  enumDesc(file_transportation_v1_service, 1);

/**
 * Services
 *
 * @generated from service transportation.v1.ServiceQueriesService
 */
export const ServiceQueriesService: GenService<{
  /**
   * @generated from rpc transportation.v1.ServiceQueriesService.GetService
   */
  getService: {
    methodKind: "unary";
    input: typeof GetServiceRequestSchema;
    output: typeof GetServiceResponseSchema;
  },
  /**
   * @generated from rpc transportation.v1.ServiceQueriesService.ListServices
   */
  listServices: {
    methodKind: "unary";
    input: typeof ListServicesRequestSchema;
    output: typeof ListServicesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_transportation_v1_service, 0);

/**
 * @generated from service transportation.v1.ServiceCommandsService
 */
export const ServiceCommandsService: GenService<{
  /**
   * @generated from rpc transportation.v1.ServiceCommandsService.CreateService
   */
  createService: {
    methodKind: "unary";
    input: typeof CreateServiceRequestSchema;
    output: typeof CreateServiceResponseSchema;
  },
  /**
   * @generated from rpc transportation.v1.ServiceCommandsService.UpdateService
   */
  updateService: {
    methodKind: "unary";
    input: typeof UpdateServiceRequestSchema;
    output: typeof UpdateServiceResponseSchema;
  },
  /**
   * @generated from rpc transportation.v1.ServiceCommandsService.DeleteService
   */
  deleteService: {
    methodKind: "unary";
    input: typeof DeleteServiceRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc transportation.v1.ServiceCommandsService.TransitionService
   */
  transitionService: {
    methodKind: "unary";
    input: typeof TransitionServiceRequestSchema;
    output: typeof TransitionServiceResponseSchema;
  },
  /**
   * @generated from rpc transportation.v1.ServiceCommandsService.AssignService
   */
  assignService: {
    methodKind: "unary";
    input: typeof AssignServiceRequestSchema;
    output: typeof AssignServiceResponseSchema;
  },
  /**
   * @generated from rpc transportation.v1.ServiceCommandsService.UnassignService
   */
  unassignService: {
    methodKind: "unary";
    input: typeof UnassignServiceRequestSchema;
    output: typeof UnassignServiceResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_transportation_v1_service, 1);

